export const triggerRequestDemoClick = () => {
  const requestDemoLink = document.querySelector('#request-demo-link')
  if (requestDemoLink) requestDemoLink.click()
}